import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CTAButton } from './CTAButton';

export const StickyBar = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling down a bit (past the hero)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100 }}
          animate={{ y: 0 }}
          exit={{ y: 100 }}
          className="fixed bottom-0 left-0 w-full z-50 p-4"
        >
          <div className="max-w-4xl mx-auto bg-navy-800/95 backdrop-blur-lg border border-white/20 rounded-2xl p-4 shadow-[0_-10px_40px_rgba(0,0,0,0.6)] flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="text-white font-bold text-lg md:text-xl text-center sm:text-left flex items-center gap-2">
              <span className="w-2 h-2 bg-red-500 rounded-full animate-ping"></span>
              Silver 2.0 FY Offer <span className="text-red-400">Ends Tonight</span>
            </div>
            <CTAButton text="Upgrade Now" className="w-full sm:w-auto !py-3 !px-6 text-base" icon={false} />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};